export const getURIParams = (params: unknown): string => {
	return Object.keys(params)
		.reduce(
			(prev: string, cur: string) => {
				const p = params as {[key: string]: string | number};

				if (p[cur] == null) {
					return prev;
				}

				return `${prev}${(prev ? '&' : '')}${cur}=${encodeURIComponent(String(p[cur]))}`;
			},
			'',
		);
};